module.exports = __webpack_public_path__ + "static/media/about-image-2.c68419dc.png";